<div class="page">
    <div class="title">
        <div class="titleValue">{{ "issues.title" | transloco }}</div>
        <div class="line"></div>
    </div>
    <div class="buttons">
        <div class="buttonsFiltros">
            <div class="titleFiltros">{{ "issues.history" | transloco }}</div>
            <!-- <button class="filtro"><mat-icon>filter_list</mat-icon>{{ "issues.filters" | transloco }}</button> -->
        </div>
        <button class="addCaso" (click)="navigateToNuevoCaso()">{{ "issues.newIssue" | transloco }}</button>
    </div>
    <div class="casos" *ngIf="ticketsAbiertos.length > 0">
        <div class="casosLabel">{{ "issues.open" | transloco }}</div>
        <div class="casosList" *ngFor="let ticketAbierto of ticketsAbiertos">
            <div class="casosCardGroup">
                <div class="estado" [style]="ticketAbierto.status === 'assign' || ticketAbierto.status === 'plan' ? 'background-color: blue; color: white' : 'background-color: var(--primary-color); color: white'">{{buscarEstadoPorNombre(ticketAbierto.status)}}</div>
                <div class="casosCard" (click)="goTicket(ticketAbierto.ID)">
                    <div class="infoLabel">{{ "issues.issueNumber" | transloco }}: <div style="font-weight: 600;">{{ticketAbierto.ID}}</div>
                    </div>
                    <div class="infoLabel">{{ "issues.serialNumber" | transloco }}: <div style="font-weight: 600;">{{ticketAbierto.numserie}}</div>
                    </div>
                    <div *ngIf="ticketAbierto.contents != null && ticketAbierto.contents != ''" class="infoLabel">{{ "issues.description" | transloco }}: <div style="font-weight: 600;"><div [innerHTML]="ticketAbierto.contents"></div></div>
                    </div>
                    <div class="infoLabel">{{ "issues.openDate" | transloco }}: <div style="font-weight: 600;">{{formatFecha(ticketAbierto.date)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="casos" *ngIf="ticketsCerrados.length > 0">
        <div class="casosLabel">{{ "issues.closed" | transloco }}</div>
        <div class="casosList" *ngFor="let ticketCerrado of ticketsCerrados">
            <div class="casosCardGroup">
                <div class="estado" [style]="ticketCerrado.status === 'old_done' ? 'background-color: greenyellow;' : 'background-color: red; color: white'">{{buscarEstadoPorNombre(ticketCerrado.status)}}</div>
                <div class="casosCard" (click)="goTicket(ticketCerrado.ID)">
                    <div class="infoLabel">{{ "issues.issueNumber" | transloco }}: <div style="font-weight: 600;">{{ticketCerrado.ID}}</div>
                    </div>
                    <div class="infoLabel">{{ "issues.serialNumber" | transloco }}: <div style="font-weight: 600;">{{ticketCerrado.numserie}}</div>
                    </div>
                    <div *ngIf="ticketCerrado.contents != null && ticketCerrado.contents != ''" class="infoLabel">{{ "issues.description" | transloco }}: <div style="font-weight: 600;"><div [innerHTML]="ticketCerrado.contents"></div></div>
                    </div>
                    <div class="infoLabel">{{ "issues.openDate" | transloco }}: <div style="font-weight: 600;">{{formatFecha(ticketCerrado.date)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="casos" *ngIf="ticketsCerrados.length === 0 && ticketsAbiertos.length === 0">
        <div class="casosLabel">{{ "issues.noIssues" | transloco }}</div>
    </div>
</div>